import styled from "styled-components";
import { Button } from "../../Components/Button";

export const InvitationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.spacing.large};
  width: 100%;

  > img {
    width: 70%;
    height: auto;
  }

  > button {
    width: 100%;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    > img {
      max-width: 15rem;
    }
  }
`;

export const ModalTitle = styled.h1`
  margin: 0;
  margin-bottom: ${(props) => props.theme.spacing.medium};
  text-align: center;

  > span {
    color: ${(props) => props.theme.colors.accent2};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 1.5rem;
  }
`;

export const StackItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.spacing.small};
  width: 100%;

  > * {
    width: 100%;
  }
`;

export const ExternalRegisterButton = styled(Button)`
  color: ${(p) => p.theme.colors.font.primary};
  background-color: ${(p) => p.theme.colors.primary};
  border: 1px solid ${(p) => p.theme.colors.border};
`;

export const FormSeparator = styled.span`
  text-align: center;
  font-weight: 600;
`;
